/**
 * PC-v2.2-C2.1 — el selector de periodo de la analítica (ver `periodo-analitico.ts`): las opciones comunes y, en
 * «Personalizado», Desde / Hasta. Quien lo usa guarda el resultado en la URL y decide el límite de días.
 */
import type { ReactNode } from 'react';

import { cambioDePeriodo, OPCIONES_PERIODO, type ClavePeriodo, type Rango } from '../periodo-analitico.ts';

export function SelectorPeriodo({ idBase, periodo, rango, error, fijar, estilo }: {
  idBase: string;
  periodo: ClavePeriodo;
  /** Las fechas del periodo (en personalizado, las de la URL aunque no sean válidas). */
  rango: Rango;
  /** El motivo por el que el periodo no se puede pedir, si lo hay (se enseña junto a las fechas). */
  error: string | null;
  fijar: (cambios: Record<string, string>) => void;
  estilo?: 'portal' | 'interno';
}): ReactNode {
  const clase = estilo === 'portal' ? 'campo filtros-calidad' : 'campo';
  const caja = estilo === 'portal' ? { margin: 0, maxWidth: 260 } : { margin: 0 };
  return (
    <>
      <div className={clase} style={caja}>
        <label htmlFor={`${idBase}-p`}>Periodo</label>
        <select id={`${idBase}-p`} value={periodo} onChange={(e) => fijar(cambioDePeriodo(e.target.value, rango))}>
          {OPCIONES_PERIODO.map(([k, t]) => <option key={k} value={k}>{t}</option>)}
        </select>
      </div>
      {periodo === 'personalizado' && (
        <>
          <div className={clase} style={{ margin: 0 }}>
            <label htmlFor={`${idBase}-d`}>Desde</label>
            <input
              id={`${idBase}-d`} type="date" value={rango.desde} max={rango.hasta} aria-invalid={error !== null}
              aria-describedby={error === null ? undefined : `${idBase}-err`} onChange={(e) => fijar({ desde: e.target.value })}
            />
          </div>
          <div className={clase} style={{ margin: 0 }}>
            <label htmlFor={`${idBase}-h`}>Hasta</label>
            <input
              id={`${idBase}-h`} type="date" value={rango.hasta} min={rango.desde} aria-invalid={error !== null}
              aria-describedby={error === null ? undefined : `${idBase}-err`} onChange={(e) => fijar({ hasta: e.target.value })}
            />
          </div>
        </>
      )}
      {error !== null && <p id={`${idBase}-err`} className="pequena" role="alert" style={{ flexBasis: '100%', margin: 0, color: 'var(--error)' }}>{error}</p>}
    </>
  );
}
